(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationDialogController', LanguageLocalizationDialogController);

    LanguageLocalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LanguageLocalization'];

    function LanguageLocalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LanguageLocalization) {
        var vm = this;

        vm.languageLocalization = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.languageLocalization.id !== null) {
                LanguageLocalization.update(vm.languageLocalization, onSaveSuccess, onSaveError);
            } else {
                LanguageLocalization.save(vm.languageLocalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:languageLocalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
